export class AboutYou {
    public static Init(): void {
        new AboutYou();
    }

    private changeEmailElement = document.getElementById("change-email");

    constructor() {
        if (this.changeEmailElement) {
            this.changeEmailElement.addEventListener("click", (event) => this.onChangeEmailClicked(event));
        }
    }

    private onChangeEmailClicked(ev: Event): void {
        ev.preventDefault();
        let email = <HTMLInputElement>document.getElementById("Email");

        email.removeAttribute("disabled");
        email.focus();
        email.select();

        this.changeEmailElement.parentElement.removeChild(this.changeEmailElement);
    }
}

if (document.body.dataset.pageInit == "aboutyou") {
    AboutYou.Init();
}